module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"OrderOrLotAllocationMethods\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/order-or-lot-allocation-methods/order-or-lot-allocation-methods.component.html
// module id = ./src/app/order-or-lot-allocation-methods/order-or-lot-allocation-methods.component.html
// module chunks = main